<template>
    <oc-page title="Profile">
        <h4 class="section-title">Profile</h4>
        <div class="hr mb-4" />

        <table class="table">
            <tr v-for="(label, field) in fields">
                <th>{{label}}</th>
                <td>
                    <template v-if="user[field]">
                        {{user[field]}}
                    </template>
                    <i v-else class="text-muted">(not set)</i>
                </td>
            </tr>
        </table>
    </oc-page>
</template>

<script>
import AuthStateMixin from '@/mixins/AuthStateMixin'

export default {
    name: "profile",
    mixins: [AuthStateMixin],
    data() {
        let fields = {
            id: 'ID',
            username: 'Username',
            name: 'Name',
            email: 'E-mail',
            passwordExpiryDate: 'Password Expiry Date',
            passwordLastUpdate: 'Password Last Update',
            lastLoginDate: 'Last Login Date',
            lastUpdate: 'Last Update',
            creationDate: 'Creation Date'
        }

        return {
            fields,
            user: {}
        }
    },
    created() {
        API.GET('app', 'profile').then(resp => {
            this.user = resp.getData()
        })
    }
}
</script>

<style scoped>
.table th {
    background: #f3f3f3;
}
</style>
